<script setup>
defineProps({
  unit: {
    type: Object,
    required: true,
  },
});

const formatCurrency = (value) => {
  return new Intl.NumberFormat("th-TH", {
    style: "currency",
    currency: "THB",
    minimumFractionDigits: 0,
  }).format(value || 0);
};

const formatDate = (value) => {
  if (!value) return "-";
  return new Intl.DateTimeFormat("th-TH", {
    year: "numeric",
    month: "short",
    day: "numeric",
  }).format(new Date(value));
};
</script>
<template>
  <div class="card border-0 shadow-sm rounded-4 h-100">
    <div class="card-body p-4">
      <div class="d-flex align-items-center justify-content-between mb-4">
        <div>
          <h5 class="fw-bold mb-1">สรุปการเงิน</h5>
          <div class="text-muted small">ค่าส่วนกลางปัจจุบันและยอดค้างชำระ</div>
        </div>
        <div class="icon-box bg-warning-subtle text-warning">
          <i class="bi bi-wallet2"></i>
        </div>
      </div>

      <div class="summary-box bg-light rounded-4 p-3 mb-3">
        <div class="text-muted small mb-1">ค่าส่วนกลางต่อเดือน</div>
        <div class="fw-bold fs-4">{{ formatCurrency(unit.monthlyFee) }}</div>
      </div>

      <div
        class="summary-box rounded-4 p-3 mb-4"
        :class="
          unit.balance > 0
            ? 'bg-danger bg-opacity-10'
            : 'bg-success bg-opacity-10'
        "
      >
        <div class="text-muted small mb-1">ยอดค้างชำระรวม</div>
        <div
          class="fw-bold fs-4"
          :class="unit.balance > 0 ? 'text-danger' : 'text-success'"
        >
          {{ formatCurrency(unit.balance) }}
        </div>
      </div>

      <div class="vstack gap-3">
        <div class="d-flex align-items-center justify-content-between">
          <span class="text-muted">ชำระล่าสุด</span>
          <span class="fw-semibold">{{
            formatDate(unit.lastPaymentDate)
          }}</span>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <span class="text-muted">เจ้าของยูนิต</span>
          <span class="fw-semibold">{{ unit.ownerName || "-" }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.icon-box {
  width: 52px;
  height: 52px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.15rem;
}
</style>
